export default "__VITE_ASSET__31cb349b__"